module.exports = __webpack_public_path__ + "static/img/cooperator.7d8db8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/premier_league/cooperator.png
// module id = 9RVp
// module chunks = 1